<template>
  <div>
    <div class="feature-top">
      <product-feature-summary
        :imagePath="'/static/products/reply-call/feature/summary.jpg'"
        :altText="`お客様呼出しシステムのリプライコール`"
        :headerText="
          `リプライコールなら、お客様の満足度もアップ！
          待ち時間をもっともっと快適に過ごしていただくことができます。`
        "
        :detailText="
          `安心して業務が行える「受信確認機能」や「圏外お知らせ機能」、使用場所を選ばず広い敷地でもOK！
          かんたん操作で、すぐに使いこなせます！`
        "
        :color="'green'"
      />

      <div class="reply-call-usage">
        <div class="usage-example">
          <div class="title">スタッフは･･･</div>
          <div class="heading">
            スマートにお呼び出し、スムーズに対応できる。
          </div>
          <img
            style="height: 80px;"
            v-lazy="'/static/products/reply-call/feature/usage_example_01.png'"
          />
          <div class="usage-point">
            お客様をお呼びする時に大きな声を出す必要がなくなります。
          </div>
          <div class="usage-point">
            間違えて別の商品をお客様に渡してしまうといったミスが<br />
            大幅に減ります。
          </div>
          <div class="usage-point">
            待ち時間中に別の商品を購入してもらえるチャンスが増えます。
          </div>
          <div class="usage-point">
            ウェイティングの途中で帰る方が減るので売り上げアップが<br />
            期待できます。
          </div>
        </div>
        <div class="usage-example">
          <div class="title">お客様は･･･</div>
          <div class="heading">待ち時間を有効に活用できる。</div>
          <img
            v-lazy="'/static/products/reply-call/feature/usage_example_02.png'"
          />
          <div class="usage-point">
            別の場所へ移動したり本を読んだりできるので気軽に待てます。
          </div>
          <div class="usage-point">
            自分の順番が来たことがハッキリと分かります。
          </div>
          <div class="usage-point">
            うるさい場所でも確実に呼ばれたことが分かります。
          </div>
          <div class="usage-point">
            車の中で音楽を聴いたりしながら順番を待つことができます。
          </div>
          <div style="font-weight: bold;">
            <div class="appeal-title">
              抗菌樹脂採用
            </div>
            <div class="appeal-detail">
              <p>受信機本体は清潔・安心。</p>
              <p>気持ちよく利用できます。</p>
            </div>
          </div>
        </div>
      </div>

      <h2>
        その差、歴然。<br />
        これまでのパーソナルコールシステムと、ぜひお比べください。
      </h2>

      <div class="feature-content">
        <content-header
          headingTitle="受信確認機能"
          title="トラブルが最小限！だから納得！"
          fontColor="black"
          borderColor="green"
          headingTitleWidth="240"
        />
        <p>
          送信機から送信した信号を受信機がキャッチすると、自動で受信確認信号を送信機へ返信（受信確認機能）します。
        </p>
        <p>
          送信機側でも信号が届いていることを確認できるため、安心して業務が行えます。また不要なトラブルもなくなります。
        </p>
      </div>

      <div class="feature-content">
        <content-header
          headingTitle="「圏外」お知らせ機能"
          title="お客様は自由に移動可能！だから快適！"
          fontColor="black"
          borderColor="green"
          headingTitleWidth="240"
        />
        <p>
          受信機が「圏外」になった場合には、異常音とバイブレーション、圏外表示でしっかりとお知らせ。お客様は送信機からの信号が届くエリアを
        </p>
        <p>
          把握できるようになるため、待ち時間の間を、安心して過ごすことができます。
        </p>
      </div>

      <div class="feature-content">
        <content-header
          headingTitle="「2WAY」電源対応"
          title="使用場所を選ばない！だから便利！"
          fontColor="black"
          borderColor="green"
          headingTitleWidth="240"
        />
        <p>
          送信機は、AC電源はもちろん、電池での駆動にも対応。アウトドアでのイベントや、AC電源の確保が難しい場所などでも利用することができます。
        </p>
      </div>

      <div class="feature-content">
        <content-header
          headingTitle="特定小電力タイプ"
          title="広い敷地でもOK！だから安心！"
          fontColor="black"
          borderColor="green"
          headingTitleWidth="240"
        />
        <p>
          通信方式に特定小電力無線を採用。これまでの一般的なシステムよりも、通信距離が大幅に長くなっています（見通し約100m）。
        </p>
        <p>
          そのため広い敷地の施設でも安心してご利用 OK!
          また中継機（オプション）の活用で通信可能距離はさらに拡がります。
        </p>
      </div>

      <div class="feature-content">
        <content-header
          headingTitle="コストパフォーマンス"
          title="お求めやすいプライスを実現！だから満足！"
          fontColor="black"
          borderColor="green"
          headingTitleWidth="240"
        />
        <p>
          これまでのコードレス・パーソナルコールシステム製品よりもさらに充実した機能を実現。
        </p>
      </div>
    </div>

    <div class="feature-section" v-if="this.$isPC">
      <div class="circle-parent">
        <div class="circle-heading green">
          <span class="circle-heading-title"> 操作の流れ </span>
        </div>
      </div>

      <div class="operation-flow">
        <div class="header">
          <h2>
            かんたん操作で、お客様をお呼び出し。<br />
            すぐに使いこなせることも、リプライコールの魅力です。
          </h2>
        </div>
        <div class="body">
          <div class="operation-empty" />

          <div class="operation-block">
            <img
              v-lazy="'/static/products/reply-call/feature/operation_01.jpg'"
            />
            <div class="operation-block-title">
              1. 受信機をお客様へお渡し
            </div>
            <p>
              受信機に設定された番号を確認して、お客様へお渡しください。
            </p>
          </div>

          <div class="operation-arrow" />

          <div class="operation-block">
            <img
              v-lazy="'/static/products/reply-call/feature/operation_02.jpg'"
            />
            <div class="operation-block-title">
              2. 呼び出したい<br />
              &nbsp;&nbsp;&nbsp;&nbsp;受信機の番号を入力
            </div>
            <p>
              送信機の10キーを利用して、呼び出したい受信機の番号を入力します。
              送信機の表示窓には入力した番号がされます。
            </p>
          </div>

          <div class="operation-arrow" />

          <div class="operation-block">
            <img
              v-lazy="'/static/products/reply-call/feature/operation_03.jpg'"
            />
            <div class="operation-block-title">
              3. 呼び出し
            </div>
            <p>
              ［CALL］キーをプッシュして受信機を呼び出します。
            </p>
          </div>

          <div class="operation-arrow" />

          <div class="operation-arrow" />

          <div class="operation-block">
            <img
              v-lazy="'/static/products/reply-call/feature/operation_04.jpg'"
            />
            <div class="operation-block-title">
              4. 呼び出し確認
            </div>
            <p>
              受信機に信号が届くと、送信機の表示窓のLED表示が赤から緑に変わります。
            </p>
          </div>

          <div class="operation-arrow" />

          <div class="operation-block">
            <img
              v-lazy="'/static/products/reply-call/feature/operation_05.jpg'"
            />
            <div class="operation-block-title">
              5. 呼び出し受信
            </div>
            <p>
              受信機は呼び出しを受けるとLED・番号表示（受信機番号または送信機番号）・ブザー音・バイブレーションでお知らせ（任意で切り替え可能）。
            </p>
          </div>

          <div class="operation-arrow" />

          <div class="operation-block">
            <img
              v-lazy="'/static/products/reply-call/feature/operation_06.jpg'"
            />
            <div class="operation-block-title">
              6. 呼び出し停止
            </div>
            <p>
              受信機のSTOPボタンを押すことで、受信LED・呼び出しブザー音・バイブレーションをSTOPできます。
            </p>
          </div>

          <div class="operation-empty" />
        </div>
      </div>
    </div>

    <div class="feature-section">
      <div class="circle-parent">
        <div class="circle-heading green">
          <span class="circle-heading-title"> 導入例 </span>
        </div>
      </div>

      <div class="introduction-example">
        <div class="header">
          <h2>
            快適に待ち時間を過ごせる場所は、<br />
            何度も足を運んでいただける場所になります。
          </h2>
        </div>
        <div class="body">
          <div class="example-block">
            <div class="example-title">ファーストフードでは</div>
            <router-link to="/column/13">
              <img
                v-lazy="'/static/products/reply-call/feature/example_01.png'"
              />
            </router-link>
          </div>
          <div class="example-block">
            <div class="example-title">病院では</div>
            <router-link to="/column/15">
              <img
                v-lazy="'/static/products/reply-call/feature/example_02.png'"
              />
            </router-link>
          </div>
          <div class="example-block">
            <div class="example-title">レジャー施設では</div>
            <router-link to="/column/23">
              <img
                v-lazy="'/static/products/reply-call/feature/example_03.png'"
              />
            </router-link>
          </div>
          <div class="example-block">
            <div class="example-title">屋外施設では</div>
            <router-link to="/column/21">
              <img
                v-lazy="'/static/products/reply-call/feature/example_04.png'"
              />
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <div class="feature-section">
      <div class="circle-parent">
        <div class="circle-heading green">
          <span class="circle-heading-title"> 主な機能 </span>
        </div>
      </div>

      <div class="main-function">
        <div class="body">
          <div class="product-block">
            <div class="product-block-header">
              <h3 class="product-genre">送信機</h3>
              <div class="product-detail">
                <p>操作性を熟慮して設計されたボタン</p>
                <p>サイズ＆フォルム。電池駆動にも</p>
                <p>対応した、画期的な送信機。</p>
              </div>
            </div>
            <img
              class="product-image"
              v-lazy="'/static/products/reply-call/feature/function_01.jpg'"
            />
            <div class="function">
              <div class="function-title">
                かんたん呼び出しを実現
              </div>
              <div class="function-detail">
                呼び出す受信機の番号を入力し、［CALL］キーを押すだけの操作で
                呼び出しが完了。0を入力することで、すべての受信機を一斉に<br />
                呼び出すこともできます。
              </div>
            </div>
            <div class="function">
              <div class="function-title">
                受信確認機能を搭載
              </div>
              <div class="function-detail">
                受信機に信号が届いたかどうかを確認できる「受信確認機能」を搭載。
                受信機に呼び出し信号が届くと、送信機の表示窓の番号表示が赤から緑に変わります。
                呼び出し信号が届かなかった場合には、赤の点滅による番号表示と異常音でお知らせします。
              </div>
            </div>
            <div class="function">
              <div class="function-title">
                複数の送信機から受信機を呼び出し可能
              </div>
              <div class="function-detail">
                番号設定を行うことで、複数の送信機から受信機を呼び出すことが
                できます。複数の送信機を設置した場合でも受信機に送信機の番号を
                表示させれば、どの送信機から呼ばれたのかが受信機側でかんたんに
                把握できます。
              </div>
            </div>
            <div class="function">
              <div class="function-title">
                電池駆動にも対応
              </div>
              <div class="function-detail">
                AC 電源はもちろん電池駆動にも対応。アウトドアなど、AC電源の
                確保が難しい場所でも、送信機を活用することが可能になりました。
              </div>
            </div>
            <div class="function">
              <div class="function-title">
                活用範囲を拡げる「中継機」をご用意
              </div>
              <div class="function-detail">
                通信方式に特定小電力無線を採用しているため、一般的なコードレス・
                パーソナルコールシステムよりも、通信距離は大幅に長くなっています
                （見通し約100m）。さらに長い距離での通信を行いたい場合のために、
                中継機（オプション）もご用意しています。
              </div>
            </div>

            <div class="product-tips">
              <div class="product-tip">
                <img
                  v-lazy="'/static/products/reply-call/feature/function_02.png'"
                />
                <p>
                  受信機に信号が届くとLEDの表示が赤から緑に変化します。
                </p>
              </div>
              <div class="product-tip">
                <img
                  v-lazy="'/static/products/reply-call/feature/function_03.png'"
                />
                <p>
                  単三乾電池3本による駆動にも対応。屋外でその機能を活用できます。
                </p>
              </div>
            </div>
          </div>

          <div class="product-block">
            <div class="product-block-header">
              <h3 class="product-genre">受信機</h3>
              <div class="product-detail">
                <p>番号表示窓の「見やすさ」を徹底追究。</p>
                <p>持ちやすさや、感触にもこだわった、</p>
                <p>先進の受信機。</p>
              </div>
            </div>
            <img
              class="product-image"
              v-lazy="'/static/products/reply-call/feature/function_04.jpg'"
            />
            <div class="function">
              <div class="function-title">
                4つのスタイルで呼び出しをお知らせ
              </div>
              <div class="function-detail">
                受信LED・ブザー音・バイブレーション・番号表示の4スタイル
                で呼び出しを、分かりやすくお知らせ。本体のSTOPボタンを押せば、
                呼び出しのお知らせをワンタッチで停止できます。
              </div>
            </div>
            <div class="function">
              <div class="function-title">
                送信機へ「呼び出し受信」を自動返信
              </div>
              <div class="function-detail">
                送信機からの呼び出し信号を受信した際に、自動で送信機へ「受信」
                したことを返信。送信側は、信号が届いているかどうかを心配する
                必要がありません。
              </div>
            </div>
            <div class="function">
              <div class="function-title">
                圏外表示機能搭載
              </div>
              <div class="function-detail">
                受信機が「圏外」になった場合には、異常音とバイブレーション、
                圏外表示でしっかりお知らせ。圏内に戻ると通常待ち受け状態にな
                ります。お客様は呼び出し信号が届くエリアで、安心して呼び出しを
                待つことができます。
              </div>
            </div>
            <div class="function">
              <div class="function-title">
                リチウムポリマー充電池採用
              </div>
              <div class="function-detail">
                継ぎ足し充電でのメモリ効果を抑えた、新型のリチウムポリマー充
                電池を採用しています。
              </div>
            </div>
            <div class="function">
              <div class="function-title">
                フル充電時の連続待受30時間以上のロングライフ設計
              </div>
              <div class="function-detail">
                バッテリーロングライフ設計により、連続待受時間・30時間以上を
                実現※。安心してご利用いただけます。<br />
                <span style="font-size: 12px;">
                  ※連続待受時間は、電波を正常に受信できる静止状態での平均的な利用時間です。
                  充電状態・気温などの使用環境、利用場所の電波状態などによって、ご利用時間が
                  短くになることがあります。
                </span>
              </div>
            </div>
            <div class="function">
              <div class="function-title">
                電源ON/OFF機能搭載
              </div>
              <div class="function-detail">
                携帯受信表示機はフル充電・電源OFFの状態で出荷いたします。
                商品到着後電源をONにしていただければ、すぐにご利用いただく
                ことが可能です。
              </div>
            </div>

            <div class="product-tips">
              <div class="product-tip">
                <img
                  v-lazy="'/static/products/reply-call/feature/function_05.png'"
                />
                <p>
                  電池の残量や、「圏外」かどうかがひと目でわかります。
                </p>
              </div>
              <div class="product-tip">
                <img
                  v-lazy="'/static/products/reply-call/feature/function_06.png'"
                />
                <p>
                  先進の薄型コンパクト設計。「持ちやすい」ことを追究しました。
                </p>
              </div>
            </div>
          </div>

          <div class="product-block">
            <div class="product-block-header">
              <h3 class="product-genre">充電器</h3>
              <div class="product-detail">
                <p>充電のしやすさだけでなく、</p>
                <p>お手入れのしやすさにも配慮した、</p>
                <p>信頼の充電器。</p>
              </div>
            </div>
            <img
              class="product-image"
              v-lazy="'/static/products/reply-call/feature/function_07.png'"
            />
            <div class="function">
              <div class="function-title">
                複数の受信機を一度に充電可能
              </div>
              <div class="function-detail">
                5台の受信機を一度に充電できる5連式と、10台の受信機を一度に
                充電できる10連式の2タイプの充電器をラインナップ。
                ご利用の受信機台数に合わせてお選びいただけます。
              </div>
            </div>
            <div class="function">
              <div class="function-title">
                約6時間でフル充電
              </div>
              <div class="function-detail">
                受信機のフル充電に掛かる時間は、5連式・10連式ともに約6時間。
                もちろん受信機は継ぎ足し充電できますので、こまめに充電すること
                で、1日中安心してご利用いただけます。
              </div>
            </div>
            <div class="function">
              <div class="function-title">
                かんたんお手入れを実現
              </div>
              <div class="function-detail">
                受信機の収納スペースをワンタッチで取り外すことが可能。
                ホコリやゴミなどが入り込んでしまった場合でも、かんたんに掃除
                することができます。
              </div>
            </div>
            <div class="function">
              <div class="function-title">
                水によるトラブルを予防
              </div>
              <div class="function-detail">
                水抜き用の孔を標準で装備。少量のしぶきが掛かってしまったよう
                な時は、自然に水が抜けるように設計されています。<br />
                <span style="font-size: 12px;">
                  ※本製品は防水ではありません。できるだけ水に濡れないようご注意ください。
                  万一水分が付着した場合には、速やかに乾いた布で拭き取ってください。
                </span>
              </div>
            </div>
            <div class="function">
              <div class="function-title">
                電源ON/OFFスイッチ
              </div>
              <div class="function-detail">
                電源はACアダプター6V。充電をまとめて開始/停止できる、
                一括集中スイッチを装備しています。
              </div>
            </div>

            <div class="product-tips">
              <div class="product-tip">
                <img
                  v-lazy="'/static/products/reply-call/feature/function_08.png'"
                />
                <p>
                  受信機の収納スペースは取り外しOK！お手入れがかんたんです。
                </p>
              </div>
              <div class="product-tip">
                <img
                  v-lazy="'/static/products/reply-call/feature/function_09.png'"
                />
                <p>
                  収納式接触端子を採用しているため、拭き掃除がかんたんに行えます。
                </p>
              </div>
            </div>
          </div>

          <div class="product-block">
            <div class="product-block-header">
              <h3 class="product-genre">中継機</h3>
              <div class="product-detail">
                <p>通信距離をさらに拡大。</p>
                <p>より広い範囲をリプライコールの</p>
                <p>「圏内」にする中継機。</p>
              </div>
            </div>
            <img
              class="product-image"
              v-lazy="'/static/products/reply-call/feature/function_10.png'"
            />
            <div class="function">
              <div class="function-title">
                信号の到達距離を延長
              </div>
              <div class="function-detail">
                中継機を使用することにより、信号の到達距離を大幅に延長すること
                が可能（対送信機：約100m、対受信機：約100m）になります。
                広大な敷地内でリプライコールをご利用されたいお客様に最適な
                アイテムです。中継機は何台でも増設することが可能です（9台以上
                の増設はご相談下さい）。
              </div>
            </div>
            <div class="function">
              <div class="function-title">
                受信電波強度表示機能を搭載
              </div>
              <div class="function-detail">
                受信電波強度をLEDで表示。電波が届いている/いないがひと目で
                わかるので大変便利です。<br />
                MAX60で20以上あれば確実に受信できます。
              </div>
            </div>

            <div class="product-introduction-example">
              <span>導入例</span>
              <img
                v-lazy="'/static/products/reply-call/feature/function_11.jpg'"
              />
              <p>
                リプライコールは、フロアが別れているフードコートやテラス席が用意さ
                れているフードコートにも最適。中継機の利用により通信距離が大幅アッ
                プするため、確実にお客様をお呼びすることが可能です。
              </p>
            </div>

            <div class="product-tips">
              <div class="product-tip">
                <img
                  v-lazy="'/static/products/reply-call/feature/function_14.jpg'"
                />
                <p>軽量＆コンパクトだから設置場所は自由自在。</p>
                <p>専用取付金具もご用意（別売）</p>
              </div>
              <div class="product-tip">
                <img
                  v-lazy="'/static/products/reply-call/feature/function_13.png'"
                />
                <p>
                  通信距離をさらに拡げる高感度アンテナを採用しています。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="column_nav">
      <h2 style="color: #0a518d">おすすめのコンテンツ</h2>
      <ul
        style="width: 100%; max-width: 960px; margin: 0 auto; box-sizing: border-box;"
      >
        <li>
          <a href="/choice/industry/9" target="_blank"
            ><img
              src="/static/columns/21/outdoor_facility_mv.png"
              alt="屋外施設の呼出しベルについて"
          /></a>

          <h3>
            <a href="/choice/industry/9" target="_blank"
              >屋外施設の呼出しベルについて</a
            >
          </h3>
        </li>
        <li>
          <a href="/column/11" target="_blank"
            ><img
              src="/static/columns/11/img_waiting_room_call_bell1.jpg"
              alt="待合室に呼び出しベルを導入して混雑を緩和！使い方や導入のポイントも"
          /></a>

          <h3>
            <a href="/column/11" target="_blank"
              >待合室に呼び出しベルを導入して混雑を緩和！使い方や導入のポイントも</a
            >
          </h3>
        </li>
        <li>
          <a href="/column/12" target="_blank"
            ><img
              src="/static/columns/12/img_parking_lot_call_bells1.jpg"
              alt="駐車場での呼び出しベル活用例5選！導入の注意点とおすすめ機種も"
          /></a>

          <h3>
            <a href="/column/12" target="_blank"
              >駐車場での呼び出しベル活用例5選！導入の注意点とおすすめ機種も</a
            >
          </h3>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import ProductFeatureSummary from '@/components/modules/ProductFeatureSummary'
import ContentHeader from '@/components/modules/ContentHeader'

export default {
  components: {
    ProductFeatureSummary,
    ContentHeader,
  },
}
</script>

<style scoped>
.feature-top h2 {
  color: rgb(45, 183, 68);
}

.feature-content {
  margin: 35px 0;
}

.reply-call-usage {
  display: flex;
  justify-content: space-between;
}

.sp-product .reply-call-usage {
  flex-direction: column;
  justify-content: center;
}

.reply-call-usage .usage-example {
  position: relative;

  width: 45%;
  padding: 20px;

  background-color: rgb(227, 246, 232);
}

.sp-product .usage-example {
  width: 90%;
}

.reply-call-usage .usage-example + .usage-example {
  margin-left: 2%;
}

.sp-product .reply-call-usage .usage-example + .usage-example {
  margin: 0;
}

.reply-call-usage .usage-example .title {
  font-size: 20px;
  font-weight: bold;

  width: 150px;
  padding: 2px 15px;

  color: white;
  border-radius: 20px;
  background-color: rgb(45, 183, 68);
}

.reply-call-usage .usage-example .heading {
  font-size: 18px;
  font-weight: bold;

  margin: 10px 0;
}

.reply-call-usage .usage-example img {
  position: absolute;
  top: -20px;
  right: 10px;

  width: auto;
  height: 115px;
}

.reply-call-usage .usage-example .usage-point {
  font-size: 13px;

  margin-bottom: 10px;
  padding: 5px;

  border: 1px solid rgb(45, 183, 68);
  border-radius: 4px;
  background-color: white;
}

.reply-call-usage .usage-example .appeal-title {
  display: inline-block;

  padding: 5px 30px;

  color: white;
  border-radius: 4px;
  background-color: rgb(45, 183, 68);
}

.reply-call-usage .usage-example .appeal-detail {
  font-size: 14px;

  display: inline-block;

  margin-left: 10px;

  vertical-align: middle;

  color: rgb(45, 183, 68);
}

.reply-call-usage .usage-example .appeal-detail p {
  margin: 0;
}

.feature-section .header h2 {
  color: rgb(45, 183, 68);
}

.feature-section .operation-flow {
  width: 900px;
  margin: 0 auto;

  border-radius: 5px;
  background-color: rgb(218, 243, 225);
}

.feature-section .operation-flow .header span {
  display: inline-block;

  width: 450px;

  text-align: left;
}

.feature-section .operation-flow .header img {
  display: inline-block;

  width: 350px;
  height: auto;
}

.feature-section .operation-flow .border {
  margin: 0 40px;

  border-bottom: 1px solid white;
}

.feature-section .operation-flow .body {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  margin: 20px 0;
}

.feature-section .operation-flow .body .operation-block {
  align-self: flex-start;

  width: 220px;
  margin-bottom: 30px;

  text-align: left;
}

.feature-section .operation-flow .body .operation-block img {
  width: auto;
  height: 128px;

  border: 1px solid rgb(45, 183, 68);
}

.feature-section .operation-flow .body .operation-block .operation-block-title {
  font-weight: bold;
  line-height: 20px;

  margin: 5px 0 10px;
}

.feature-section .operation-flow .body .operation-block p {
  font-size: 13px;

  margin: 0;
}

.feature-section .operation-flow .body .operation-arrow {
  width: 0;
  height: 0;
  margin: 52.5px 20px;

  border-top: 15px solid transparent;
  border-bottom: 15px solid transparent;
  border-left: 15px solid rgb(125, 212, 141);
}

.feature-section .operation-flow .body .operation-empty {
  width: 55px;
}

.introduction-example {
  background-color: rgb(239, 250, 241);
}

.introduction-example .body {
  width: 90%;
  max-width: 900px;
  margin: 0 auto;
}

.introduction-example .example-block {
  margin: 10px 0;
}

.introduction-example .example-block .example-title {
  font-size: 20px;
  font-weight: bold;

  color: white;
  border-radius: 4px;
  background-color: rgb(62, 191, 80);
}

.introduction-example .example-block img {
  width: 90%;
  height: auto;
  margin: 20px 0 40px;
}

.feature-section .main-function .body .product-block .product-image {
  display: block;

  width: 100%;
  height: auto;
  margin: 10px auto;
}

.product-tips {
  display: flex;
  justify-content: space-between;
}

.sp-product .product-tips {
  justify-content: center;
}

.product-tips .product-tip {
  display: inline-block;

  max-width: 200px;
  margin: 20px 5px 0;
}

.product-tips .product-tip img {
  width: 100%;
  max-width: 200px;
  height: auto;
}

.product-tips .product-tip p {
  font-size: 12px;

  margin: 0;
}

.product-introduction-example {
  margin: 15px 0;
}

.product-introduction-example span {
  font-size: 16px;
  font-weight: bold;
}

.product-introduction-example img {
  width: 100%;
  height: auto;

  border: 1px solid rgb(152, 152, 152);
}

.product-introduction-example p {
  font-size: 12px;

  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/modules/products/features/ReplyCall.vue